import React from 'react';
import { CommandCenter } from './pages/CommandCenter';
export function App() {
  return <CommandCenter data-id="element-0" />;
}